import type { SignUpData } from 'src/modules/signUp/components/Professional/types';
import { Route } from 'src/shared/route';

const getTryDifferentEmailRoute = (user: SignUpData, pathname: string) => {
  switch ('signupVersion' in user ? user.signupVersion : '') {
    case '1':
      return Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_20.path;
    case '2':
      return Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_40.path;
    case '3':
      return Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_60.path;
    case '4':
      return Route.SIGN_UP_PROFESSIONAL_PROMOTION_FB_75.path;
    default:
      return pathname === Route.SIGN_UP_INSURANCE_ORGANIZATION.path
        ? Route.SIGN_UP_INSURANCE.path
        : Route.SIGN_UP_PROFESSIONAL.path;
  }
};

export { getTryDifferentEmailRoute };
